import abs from './functions/abs';
import and from './functions/and';
import average from './functions/average';
import ceiling from './functions/ceiling';
import concatenate from './functions/concatenate';
import count from './functions/count';
import countBlanks from './functions/countBlanks';
import dateBucket from './functions/dateBucket';
import dateConvert from './functions/dateConvert';
import dateDif from './functions/dateDif';
import dateTrunc from './functions/dateTrunc';
import exp from './functions/exp';
import extract from './functions/extract';
import fact from './functions/fact';
import floor from './functions/floor';
import geomean from './functions/geomean';
import ifFunction from './functions/if';
import isBlank from './functions/isBlank';
import left from './functions/left';
import len from './functions/len';
import ln from './functions/ln';
import log from './functions/log';
import max from './functions/max';
import med from './functions/med';
import mid from './functions/mid';
import min from './functions/min';
import mod from './functions/mod';
import mode from './functions/mode';
import nullValue from './functions/nullValue';
import or from './functions/or';
import pi from './functions/pi';
import power from './functions/power';
import product from './functions/product';
import right from './functions/right';
import round from './functions/round';
import se from './functions/se';
import sqrt from './functions/sqrt';
import stdev from './functions/stdev';
import substitute from './functions/substitute';
import sum from './functions/sum';
import textjoin from './functions/textjoin';
import textsplit from './functions/textsplit';
import variance from './functions/var';
import {AnalysisFunction} from './FunctionTypes';

export const analysisFunctions: Array<AnalysisFunction> = [
  abs,
  and,
  average,
  ceiling,
  concatenate,
  count,
  countBlanks,
  dateBucket,
  dateConvert,
  dateDif,
  dateTrunc,
  extract,
  fact,
  floor,
  geomean,
  ifFunction,
  isBlank,
  left,
  len,
  ln,
  log,
  max,
  med,
  mid,
  min,
  mod,
  mode,
  or,
  power,
  product,
  right,
  round,
  se,
  sqrt,
  stdev,
  substitute,
  sum,
  textjoin,
  textsplit,
  variance,
  pi,
  exp,
  nullValue,
];
